import { BuzerIcon } from "../../../BuzerIcons";

// Form / field-group caption — the mono-uppercase label above filter groups, spec
// blocks and field rows. Same type as SectionHeader's label (so captions and
// section dividers read as one system) but WITHOUT the hairline rule: captions sit
// inside forms/cards where a full-width rule would be too heavy. `icon` adds a
// leading glyph for field-row labels.
const base = {
  fontFamily: "var(--ff-ui)", fontSize: 10, fontWeight: 600, letterSpacing: ".14em",
  color: "var(--neutral-text-subtle)", textTransform: "uppercase",
  display: "inline-flex", alignItems: "center", gap: 5,
};

export function Caption({ children, icon, style }) {
  return (
    <span style={{ ...base, ...style }}>
      {icon && <BuzerIcon name={icon} size={12} color="currentColor" />}
      {children}
    </span>
  );
}
